import { IGetInformacoesBancariasFornecedorByIdUseCase } from "../../../presentation/useCases/read/get_informacoes_bancarias_fornecedor_by_id_use_case";
import { InformacoesBancarias } from "../../models/informacoes_bancarias";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetInformacoesBancariasFornecedorByIdUseCase
 */

export class GetInformacoesBancariasFornecedorByIdUseCase implements IGetInformacoesBancariasFornecedorByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getInformacoesBancariasFornecedorById(idFornecedor: number): Promise<InformacoesBancarias | null> {

    return this.repository.getInformacoesBancariasFornecedorById(idFornecedor);

  }
}
